import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { Router } from '@angular/router';
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component';
import { HttpParams } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../services/authentication.service';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss'],
})
export class CustomerListComponent implements OnInit {
  totalItems: number;
  currentPage = 1;
  itemsPerPage = 40;

  searchName;
  searchTaxID;
  searchBranchCode;
  searchBranchName;

  searchingName = false;
  searchingTaxID = false;
  searchingBranchCode = false;
  searchingBranchName = false;
  loading = false;

  list: any[] = [];
  customerTypes = CUSTOMER_TYPES;
  buyerNameList: any[];
  buyerBranchCodeList: any[];
  buyerBranchNameList: any[];
  buyerTaxIDList: any[];

  selectedCustomerType = this.customerTypes[0];
  selectedValues: boolean[] = [];
  allChecked: boolean = false;

  modal = null;
  modalData = null;

  @ViewChild('detailModal') detailModal: CustomerDetailComponent;
  @ViewChild('deleteConfirmation') deleteConfirmationModal: TemplateRef<any>;

  constructor(
    private alertService: AlertService,
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.initData();
    this.search();
  }

  initData() {
    this.apiService.getBuyerBranch().subscribe((buyerList: any) => {
      this.buyerNameList = buyerList
        .map((obj) => obj.name)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerBranchCodeList = buyerList
        .map((obj) => obj.branch_code)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerBranchNameList = buyerList
        .map((obj) => obj.branch_name)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      this.buyerTaxIDList = buyerList
        .map((obj) => obj.tax_id)
        .filter((item) => item)
        .filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
    });
  }

  search(resetPage: boolean = true) {
    if (resetPage) {
      this.currentPage = 1;
    }

    let params = new HttpParams()
      .set('page', this.currentPage.toString())
      .set('page_size', this.itemsPerPage.toString())
      .set('required_pagination', 'true');

    if (this.searchName) {
      params = params.append('name', this.searchName);
    }

    if (this.searchTaxID) {
      params = params.append('tax_id', this.searchTaxID);
    }

    if (this.searchBranchCode) {
      params = params.append('branch_code', this.searchBranchCode);
    }

    if (this.searchBranchName) {
      params = params.append('branch_name', this.searchBranchName);
    }

    this.loading = true;
    this.apiService
      .getBuyerBranch(params)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (response) => {
          this.list = response.results;
          this.totalItems = response.count;
          this.selectedValues = Array(this.totalItems).fill(false);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  clearSearch() {
    this.searchName = null;
    this.searchTaxID = null;
    this.searchBranchCode = null;
    this.searchBranchName = null;
    this.search();
  }

  pageChanged() {
    this.search(false);
    this.allChecked = false;
  }

  optionChanged() {
    this.currentPage = 1;
    this.search();
  }

  openModal(index) {
    this.detailModal.open(this, this.selectedCustomerType, this.list[index]);
  }

  issue(index) {
    const id = this.list[index].id;
    this.router.navigate(['document', 'issue', { buyer_branch: id }]);
  }

  reloadDropdown() {
    this.initData();
    this.search();
  }

  selectDeselectAll(checked: boolean): void {
    this.selectedValues = Array(this.totalItems).fill(checked);
    this.allChecked = checked;
    return;
  }

  isAllSelect(): void {
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        this.allChecked = false;
      }
    }
    this.allChecked = true;
  }

  getSelectId(): string {
    const selectedId = [];
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        selectedId.push(this.list[i].id);
      }
    }
    return selectedId.join(',');
  }

  getExportExcel() {
    const params = {
      search_box: this.getSelectId(),
    };

    this.apiService.getCustomerExcel(params).subscribe(
      (obj) => {
        const currentDate = moment().format('DD-MM-YYYY');
        const filename = `${currentDate}_customer_export.xlsx`;
        this.sniff('DOWNLOAD_XLS', filename);
        this.apiService.createDownloadFile(obj, filename);
      },
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'CUS_INFO',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  confirmDelete(index): void {
    this.modalData = this.list[index];
    this.modal = this.modalService.open(
      this.deleteConfirmationModal,
      {
        backdrop: 'static',
        centered: true
      });
  }

  confirmedDelete(customerId: number): void {
    this.apiService.deleteBuyerBranch(customerId).subscribe(
      (res) => {
        this.search();
        this.sniff('DELETE_CUSTOMER', this.modalData.name);
        this.closeModal();
      },
      (err) => {
        this.closeModal();
        this.alertService.toastNotify({
          type: 'error',
          text: err.error.detail,
          timer: 3000,
        });
      });
  }

  closeModal(): void {
    this.modal.close();
    this.modal = null;
    this.modalData = null;
  }

  get isAccountantAdmin(): boolean {
    return this.authService.isAccountantAdmin();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.ts